import type { BookingStatus } from "@repo/types";

export const bookingStatusLabels: Record<BookingStatus, string> = {
  pending: "未報到",
  checked_in: "報到",
  no_show: "NoShow",
  paid: "已結帳",
  completed: "完成",
  cancelled: "已刪除"
};

export const bookingStatusLabelsMap = bookingStatusLabels;
